import '../backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ElapsedTimeMetricAdapter } from './elapsed-time-metric.adapter';

import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { PipelinePolicy } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PipelinePolicy)
})
export class PipelinePolicyAdapter {
    private static readonly alertAdapter = new ElapsedTimeMetricAdapter();

    public toResource(pipelinePolicy: PipelinePolicy): Model.PipelinePolicy {
        const modelPipelinePolicy: Model.PipelinePolicy = {
            elapsedTimeMetric:  PipelinePolicyAdapter.alertAdapter.toResource(pipelinePolicy.elapsedTimeMetric),
        };
        return modelPipelinePolicy;
    }

    public toModel(modelPipelinePolicy: Model.PipelinePolicy): PipelinePolicy {
        const pipelinePolicy: PipelinePolicy = new PipelinePolicy();
        pipelinePolicy.elapsedTimeMetric = PipelinePolicyAdapter.alertAdapter.toModel(modelPipelinePolicy.elapsedTimeMetric);
        return pipelinePolicy;
    }
}
